import React from 'react';
import { LabelProps } from '../../../types';


export const HmLabel: React.FC<LabelProps> = ({ 
  text, 
  required = false,
  className = '',
  fontWeight = 'medium'
}) => {
  return (
    <label className={`block text-sm font-${fontWeight} text-gray-700 dark:text-gray-200 ${className}`}>
      {text}
      {required && <span className="text-primary-500 ml-1">*</span>}
    </label>
  );
};
